import { create } from "zustand"
import { persist } from "zustand/middleware"

export const orgSearchStore = create(
  persist(
    (set) => ({
      // 검색 및 필터 상태
      appliedCategory: "",
      appliedKeyword: "",

      // 즐겨찾기 상태
      favorites: [],

      // Actions
      setSearch: (category, keyword) =>
        set({
          appliedCategory: category,
          appliedKeyword: keyword
        }),

      toggleFavorite: (id) =>
        set((state) => ({
          favorites: state.favorites.includes(id)
            ? state.favorites.filter((favId) => favId !== id)
            : [...state.favorites, id]
        })),

      resetSearch: () =>
        set({
          appliedCategory: "",
          appliedKeyword: "",
          isOnlyFav: false
        })
    }),
    {
      name: "mc-org" // 로컬스토리지 키 이름
    }
  )
)
